__webpack_require__.p = "https://lf-lemon8-web-sg.ttwstatic.com/obj/lemon8-web-sg/lemon8_web/legal/default/";